import { render } from "./RegisterSuccess.vue?vue&type=template&id=33a8214a&scoped=true"
import script from "./RegisterSuccess.vue?vue&type=script&lang=js"
export * from "./RegisterSuccess.vue?vue&type=script&lang=js"

import "./RegisterSuccess.vue?vue&type=style&index=0&id=33a8214a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a8214a"]])

export default __exports__